// NOTICE: KAPTION-INTEGRATION
// template-languages.UI.1..3 — which Kaption utility-template languages agents
// are offered, and which one the picker opens on. Codes are the template name
// suffixes (kaption_v2_followup_r1_att1_<code>). The account payload carries
// `kaption_template_languages` (already defaulted server-side); the fallback
// here only covers payloads from before the setting existed.

export const SUPPORTED_TEMPLATE_LANGUAGES = [
  'es',
  'en',
  'pt_BR',
  'fr',
  'de',
  'it',
];
export const DEFAULT_TEMPLATE_LANGUAGES = ['es', 'en', 'pt_BR'];

// 'pt', 'pt-BR', 'es_AR', 'en-US' → the template code, or null when unsupported.
export const toTemplateLanguage = code => {
  if (!code) return null;
  const raw = String(code).trim().replace('-', '_');
  if (SUPPORTED_TEMPLATE_LANGUAGES.includes(raw)) return raw;
  const base = raw.split('_')[0].toLowerCase();
  if (base === 'pt') return 'pt_BR';
  return SUPPORTED_TEMPLATE_LANGUAGES.includes(base) ? base : null;
};

// UI.1 — the account's allowed list, in SUPPORTED order. Never empty.
export const allowedTemplateLanguages = account => {
  const stored = account?.kaption_template_languages;
  const codes = (Array.isArray(stored) ? stored : [])
    .map(toTemplateLanguage)
    .filter(Boolean);
  if (!codes.length) return [...DEFAULT_TEMPLATE_LANGUAGES];
  return SUPPORTED_TEMPLATE_LANGUAGES.filter(code => codes.includes(code));
};

// UI.2 — conversation's detected language if allowed, else the account locale
// if allowed, else the first allowed language. Never falls back to 'en' blindly.
export const defaultTemplateLanguage = ({
  conversationLanguage,
  accountLocale,
  allowed = DEFAULT_TEMPLATE_LANGUAGES,
} = {}) => {
  const list = allowed.length ? allowed : DEFAULT_TEMPLATE_LANGUAGES;
  const candidates = [conversationLanguage, accountLocale].map(
    toTemplateLanguage
  );
  return candidates.find(code => code && list.includes(code)) || list[0];
};
